/**
 * Big Waster API
 * This is a Big Waster API.
 *
 * OpenAPI spec version: 1.0
 * Contact: terry.wong@futureimpactlab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The ItemItemTranslationParam model module.
 * @module model/ItemItemTranslationParam
 * @version 1.0
 */
class ItemItemTranslationParam {
    /**
     * Constructs a new <code>ItemItemTranslationParam</code>.
     * @alias module:model/ItemItemTranslationParam
     */
    constructor() { 
        
        ItemItemTranslationParam.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ItemItemTranslationParam</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ItemItemTranslationParam} obj Optional instance to populate.
     * @return {module:model/ItemItemTranslationParam} The populated <code>ItemItemTranslationParam</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ItemItemTranslationParam();

            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
        }
        return obj;
    }


}

/**
 * @member {String} name
 */
ItemItemTranslationParam.prototype['name'] = undefined;






export default ItemItemTranslationParam;

